import { ChakraBox, EmptySectionCard } from '@equip.health/ui';

import CareTeamProviderList from '~/components/maud/patients/profile/tabs/careplan/care-team-v2/CareTeamProviderListV2';
import CareTeamSkeleton from './CareTeamSkeleton';
import { FireflyKebabMenuItem } from '@equip.health/ui';

import { Provider } from '~/lib/types/careTeam/careTeam';
import { CareTeamTranslations } from '~/lib/constants/careTeam.constants';

const TOP_LEVEL_ID = 'care-team-v2';

type CareTeamProps = {
  hasNoInquiryOrTreatmentEpisode?: boolean;
  hasTreatmentEpisode?: boolean;
  isLoading: boolean;
  patientId?: string;
  providers: Provider[];
  showTextContent?: boolean;
  showTags?: boolean;
  getKebabMenuOptions?: (provider: Provider) => FireflyKebabMenuItem[] | undefined;
};

const CareTeam = ({
  hasNoInquiryOrTreatmentEpisode = false,
  hasTreatmentEpisode = false,
  isLoading,
  patientId,
  providers,
  showTextContent = false,
  showTags = false,
  getKebabMenuOptions,
}: CareTeamProps) => {
  if (isLoading) {
    return <CareTeamSkeleton isLoading />;
  }

  const isEmpty = providers?.length === 0;

  return (
    <>
      {isEmpty ? (
        <ChakraBox>
          <EmptySectionCard
            caption={
              hasNoInquiryOrTreatmentEpisode
                ? CareTeamTranslations.NO_INQUIRY_OR_TREATMENT_EPISODE
                : CareTeamTranslations.EMPTY_PROVIDER_TEAM
            }
            id={TOP_LEVEL_ID}
          />
        </ChakraBox>
      ) : (
        <CareTeamProviderList
          getKebabMenuOptions={getKebabMenuOptions}
          hasTreatmentEpisode={hasTreatmentEpisode}
          patientId={patientId}
          providers={providers}
          showTags={showTags}
          showTextContent={showTextContent}
        />
      )}
    </>
  );
};

export default CareTeam;
